export default "/kiban/_next/static/images/11_6L_none-16294ae7915e8fe3eb779e4286de2d28.png";